import { APP_INITIALIZER, EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { HTTP_API_CLIENT } from '@ciphr/utils/data-adapters';
import { FileExportUiService } from './features/file-export-ui.service';
import { FILE_EXPORT_POLLING_TIME } from './data-adapters/file-export-pulling-time.token';

export const provideFileExport = (httpApiClientToken: InjectionToken<HttpClient>, pollingTime = 5000): EnvironmentProviders =>
  makeEnvironmentProviders([
    { provide: HTTP_API_CLIENT, useExisting: httpApiClientToken },
    { provide: FILE_EXPORT_POLLING_TIME, useValue: pollingTime },
    { provide: APP_INITIALIZER, useFactory: fileExportFactory, deps: [FileExportUiService], multi: true },
  ]);

const fileExportFactory = (fileExportUiService: FileExportUiService) => () => fileExportUiService.files$.subscribe();
